import { Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface SectionHeaderProps {
    description?: string | null | ReactNode;
    icon?: ReactNode;
    isDisabled?: boolean;
    small?: boolean;
    textColor?: string;
    title?: string;
}

export function SectionHeader({
    description,
    icon,
    isDisabled = false,
    small,
    textColor,
    title,
}: Readonly<SectionHeaderProps>) {
    return (
        <Stack spacing={0} sx={{ color: textColor, opacity: isDisabled ? 0.5 : 1 }}>
            <Stack
                direction="row"
                spacing={1}
                sx={{
                    alignItems: 'center',
                }}
            >
                {icon}
                <Typography
                    sx={{
                        fontWeight: 'bold',
                    }}
                    variant={small ? 'body1' : 'h6'}
                >
                    {title}
                </Typography>
            </Stack>
            <Typography variant={small ? 'subtitle2' : 'subtitle1'}>{description}</Typography>
        </Stack>
    );
}
